/**
 * Client-side filters for Camp Essentials stores and marketplace listings.
 */

export const STORE_CATEGORIES = [
  { id: 'all', label: 'All Stores' },
  {
    id: 'hunting',
    label: 'Hunting & Firearms',
    keywords: ['hunt', 'archery', 'firearm', 'bow', 'ammo', 'gun', 'outdoor'],
  },
  {
    id: 'camping',
    label: 'Camping & Outdoor',
    keywords: ['camp', 'tent', 'outdoor', 'cabel', 'bass pro', 'scheels'],
  },
  {
    id: 'agriculture',
    label: 'Agriculture & Farm',
    keywords: ['farm', 'tractor', 'feed', 'seed', 'rural', 'agri', 'livestock'],
  },
  {
    id: 'forestry',
    label: 'Forestry & Land',
    keywords: ['forestry', 'timber', 'land', 'helena'],
  },
];

export function storeSearchHaystack(store) {
  return [
    store?.name,
    store?.priority_label,
    store?.brand,
    store?.address,
    store?.city,
    store?.state,
    ...(Array.isArray(store?.inventory_tags) ? store.inventory_tags : []),
  ]
    .filter(Boolean)
    .join(' ')
    .toLowerCase();
}

export function filterStores(stores, { searchQuery = '', categoryId = 'all' } = {}) {
  const q = searchQuery.trim().toLowerCase();
  const category = STORE_CATEGORIES.find((c) => c.id === categoryId);
  return (stores || []).filter((store) => {
    const haystack = storeSearchHaystack(store);
    if (q && !haystack.includes(q)) return false;
    if (!category || category.id === 'all' || !category.keywords?.length) return true;
    return category.keywords.some((kw) => haystack.includes(kw));
  });
}

export function filterListings(listings, { searchQuery = '', category = '' } = {}) {
  const q = searchQuery.trim().toLowerCase();
  return (listings || []).filter((listing) => {
    if (category && listing.category !== category) return false;
    if (!q) return true;
    const haystack = [listing.title, listing.description, listing.location_text, listing.category_display]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return haystack.includes(q);
  });
}
